export default __webpack_public_path__ + "static/blob4-a2be47b33a57b30b7bcc5efe08fa50a1.svg";